module.exports = __webpack_public_path__ + "static/img/state3.511fa10d.png";